import { render, staticRenderFns } from "./language-prompt.vue?vue&type=template&id=95d503ac&scoped=true"
import script from "./language-prompt.vue?vue&type=script&lang=ts"
export * from "./language-prompt.vue?vue&type=script&lang=ts"
import style0 from "./language-prompt.vue?vue&type=style&index=0&id=95d503ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d503ac",
  null
  
)

export default component.exports